import { z } from "zod";

import { zFromJson } from "../zod";

const zGoogleConfig = z
  .object({
    VITE_GOOGLE_CONVERSION_TAG_ID: z.string().regex(/^AW-\d+$/),
    VITE_GOOGLE_CONVERSION_LABELS: zFromJson(
      z.object({
        ORDER_CREATION: z.string().nonempty(),
      }),
    ),
  })
  .transform(({ VITE_GOOGLE_CONVERSION_TAG_ID, VITE_GOOGLE_CONVERSION_LABELS }) => ({
    googleConversionTagId: VITE_GOOGLE_CONVERSION_TAG_ID,
    googleConversionLabels: VITE_GOOGLE_CONVERSION_LABELS,
  }));
type GoogleConfig = z.infer<typeof zGoogleConfig>;

export { zGoogleConfig };
export type { GoogleConfig };
